import Web3 from 'web3'

if (!window.web3) {
    window.alert("Please switch to Metamask Rinkeby Network.")
    window.location.assign("/getMetamask")

}

const web3 = new Web3(window.web3.currentProvider)

export default web3